<script setup lang="ts">
import { CardProps } from './Card.vue'

type TeaserCardPanelProps = { cards?: CardProps[] }
const props = defineProps<TeaserCardPanelProps>()
const card = computed(() => props.cards?.[0])
</script>

<template>
  <div :class="['teaser-card-panel', card?.variant === 'product' && 'product-variant']">
    <div v-if="card" class="teaser-card-panel__grid-component">
      <Card v-bind="card" :variant="card.variant || 'basicTeaserTile'" />
    </div>
  </div>
</template>

<style lang="postcss">
.teaser-card-panel {
  grid-column: span 2;
  height: 100%;
  width: 100%;
  @media (--tablet) {
    &.product-variant {
      grid-column: auto;
    }
  }

  /* Teaser tiles with modal-slideIn */
  .card {
    .card__media {
      .product-list-modal__button,
      .rtp-modal__button {
        /* 2 tiles and basic */
        width: 100%;
        max-width: 100%;
        padding: 0;
        border: none;
      }
    }
    &.card--product {
      .card__media {
        /* 1 tile */
        .product-list-modal__button,
        .rtp-modal__button {
          height: 100%;
          max-height: 100%;
        }
      }
    }
  }
}
.teaser-card-panel.product-variant .teaser-card-panel__grid-component {
  display: flex;
  height: 100%;
  justify-content: center;
}
</style>
